import { render, staticRenderFns } from "./oneToOne.vue?vue&type=template&id=70e95dde&scoped=true"
import script from "./oneToOne.vue?vue&type=script&lang=js"
export * from "./oneToOne.vue?vue&type=script&lang=js"
import style0 from "./oneToOne.vue?vue&type=style&index=0&id=70e95dde&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e95dde",
  null
  
)

export default component.exports